import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import * as d3 from 'd3';

import styles from './TreeMap.module.scss';

const legendWidth = 150;

export const TreeMap = ({width, height, data, caption, legend, sumFunc, color}) => {
  const treemap = d3.treemap()
    .size([width, height])
    .tile(d3.treemapResquarify)(d3.hierarchy(data)
      .sum(d => sumFunc ? (sumFunc(d.size) || d.size) : d.size)
      .sort((a, b) => b.value - a.value));

  return (
    <div className={styles.container} style={{width: width + (legend ? legendWidth : 0)}}>
      {caption && <div className={styles.caption}><h3>{caption}</h3></div>}

      <div className={styles.treemap}>
        <div style={{
          position: 'relative',
          width: `${width}px`,
          height: `${height}px`,
        }}>
          {treemap.descendants().map(n => {
            return (
              <div
                key={n.data.name}
                className={cn(styles.node, (n.children ? styles.parent : styles.child))}
                style={{
                  background: (n.children ? color(n.data.name) : null),
                  left: `${n.x0}px`,
                  top: `${n.y0}px`,
                  width: `${Math.max(0, n.x1 - n.x0 - 1)}px`,
                  height: `${Math.max(0, n.y1 - n.y0 - 1)}px`,
                }}>
                {n.data.link ? (
                  <a href={n.data.link} rel="noopener noreferrer" target="_blank">
                    <span>{n.data.name}</span>
                  </a>
                ) : (
                  <span>{n.data.name}</span>
                )}
              </div>
            );
          })}
        </div>

        {legend && (
          <div className={styles.legend} style={{width: legendWidth}}>
            <strong>{legend}</strong>
            <ul>
              {treemap.descendants().filter((n, i) => n.children && i).map(n => {
                return (
                  <li key={n.data.name} style={{
                    '--color': color(n.data.name),
                  }}>{n.data.name}</li>
                );
              })}
            </ul>
          </div>
        )}

      </div>
    </div>
  );
};

TreeMap.propTypes = {
  caption: PropTypes.string,
  color: PropTypes.func,
  data: PropTypes.object.isRequired,
  height: PropTypes.number,
  legend: PropTypes.string,
  sumFunc: PropTypes.func,
  width: PropTypes.number,
};

TreeMap.defaultProps = {
  color: d3.scaleOrdinal(d3.schemeCategory10),
  height: 500,
  width: 960,
};
